<div [@routerTransition]>
    <sub-header [title]="'Products' | localize" >
        <div role="actions">
            <div class="btn-group" dropdown placement="button right">
                <button
                    id="dropdownButtonExcelOperations"
                    dropdownToggle
                    type="button"
                    class="btn btn-outline btn-outline-success btn-active-light-success dropdown-toggle me-1"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-controls="dropdownMenuExcelOperations"
                >
                    <i class="far fa-file-excel btn-md-icon"></i>
                    <span class="d-none d-md-inline-block">
                        {{ 'ExcelOperations' | localize }}
                    </span>
                </button>
                <ul
                    id="dropdownMenuExcelOperations"
                    class="dropdown-menu dropdown-menu-right dropdown-excel-operations"
                    role="menu"
                    *dropdownMenu
                    aria-labelledby="dropdownButtonExcelOperations"
                >
                    <li role="menuitem">
                        <a
                            class="dropdown-item text-gray-900"
                            id="ExportProductsToExcelButton"
                            (click)="this.showExcelColumnSelectionModal()"
                            href="javascript:;"
                        >
                            <i class="fa fa-download me-2 mt-1 text-gray-900" style="font-size: 1rem"></i>
                            {{ 'ExportToExcel' | localize }}
                        </a>
                    </li>

                    <li *ngIf="'Pages.Products.Create' | permission" role="menuitem">
                        <a
                            class="dropdown-item text-gray-900"
                            (click)="this.importDialoug = true"
                            href="javascript:;"
                        >
                            <i class="fa fa-plus me-2 mt-1 text-gray-900" style="font-size: 1rem"></i>
                            {{ 'ImportFromExcel' | localize }}
                        </a>
                        <!-- <a href="javascript:;" class="no-padding">
                            <span class="fileinput-button">
                                <p-fileUpload
                                    mode="basic"
                                    customUpload="true"
                                    name="ExcelFileUpload"
                                    #ExcelFileUpload
                                    maxFileSize="10000000"
                                    auto="auto"
                                    accept=".csv,.xls,.xlsx"
                                    (uploadHandler)="uploadExcel($event)"
                                    (onError)="onUploadExcelError()"
                                    chooseLabel="{{ 'ImportFromExcel' | localize }}"
                                ></p-fileUpload>
                            </span>
                        </a> -->
                    </li>
                </ul>
            </div>

            <button
                id="btn_create_product"
                *ngIf="'Pages.Products.Create' | permission"
                (click)="createProduct()"
                class="btn btn-primary blue"
            >
                <i class="fa fa-plus"></i>
                {{ l('CreateNewProduct') }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="input-group mb-3">
                                    <input [(ngModel)]="barCode"
                                           name="barCode"
                                           autoFocus
                                           type="text"
                                           class="form-control"
                                           [placeholder]="l('SearchBarcode')" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="input-group mb-3">
                                    <input [(ngModel)]="productCode"
                                           name="productCode"
                                           autoFocus
                                           type="text"
                                           class="form-control"
                                           [placeholder]="l('SearchProductCode')" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="input-group mb-3">
                                    <input [(ngModel)]="productName"
                                           name="productName"
                                           autoFocus
                                           type="text"
                                           class="form-control"
                                           [placeholder]="l('SearchProductName')" />&nbsp;&nbsp;&nbsp;
                                    <button class="btn btn-primary" type="submit" (click)="getProducts()">
                                        <i class="flaticon-search-1"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row" [hidden]="!advancedFiltersAreShown">
                            <div class="col-md-12"></div>
                            <div class="col-md-3">
                                <div class="my-3">
                                    <label for="DepartmentName">{{ l('Department') }}</label>
                                    <select name="departmentId"
                                            [(ngModel)]="departmentId"
                                            class="form-select"
                                            (change)="getProducts()">
                                        <option value="0">{{ l('SelectADepartment') }}</option>

                                        <option *ngFor="let item of allDepartments" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="my-3">
                                    <label for="CategoryName">{{ l('Category') }}</label>
                                    <select name="categoryId"
                                            [(ngModel)]="categoryId"
                                            class="form-select"
                                            (change)="getProducts()">
                                        <option value="0">{{ l('SelectACategory') }}</option>

                                        <option *ngFor="let item of allCategorys" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group m-form__group">
                                    <label for="BrandName">{{ l('Brand') }}</label>
                                    <select name="brandId" [(ngModel)]="brandId" class="form-select" (change)="getProducts()">
                                        <option value="0">{{ l('SelectABrand') }}</option>

                                        <option *ngFor="let item of allBrands" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group m-form__group">
                                    <label for="VendorName">{{ l('Vendor') }}</label>
                                    <select name="vendorId" [(ngModel)]="vendorId" class="form-select" (change)="getProducts()">
                                        <option value="0">{{ l('SelectAVendor') }}</option>(ochangen)

                                        <option *ngFor="let item of allVendors" value="{{ item.id }}">
                                            {{ item.displayName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="Product_ProductType">{{ l('ProductType') }}</label>
                                    <select #Product_ProductType="ngModel" class="form-select" name="ProductType"
                                            id="Product_ProductType" [(ngModel)]="productType">
                                        <option value="1">{{ l('Normal') }}</option>
                                        <option value="2">{{ l('Consignment') }}</option>
                                        <option value="3">{{ l('SerialNumber') }}</option>
                                        <option value="4">{{ l('Bulk') }}</option>
                                        <option value="5">{{ l('Repack') }}</option>
                                        <option value="6">{{ l('Service') }}</option>
                                        <option value="7">{{ l('RawMaterial') }}</option>
                                        <option value="8">{{ l('Production') }}</option>
                                        <option value="9">{{ l('SemiFinished') }}</option>
                                    </select>
                                    
                                </div>
                            </div>
                            <div class="col-md-9 text-end">
                                <button (click)="resetFilters()"
                                        class="btn btn-secondary btn-sm"
                                        id="btn-reset-filters">
                                    Reset
                                </button>
                            </div>
                        </div>
                        <div class="row my-4">
                            <div class="col-sm-12">
                                <span
                                    class="clickable-item text-muted"
                                    *ngIf="!advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown"
                                >
                                    <i class="fa fa-angle-down"></i>
                                    {{ l('ShowAdvancedFilters') }}
                                </span>

                                <span
                                    class="clickable-item text-muted"
                                    *ngIf="advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown"
                                >
                                    <i class="fa fa-angle-up"></i>
                                    {{ l('HideAdvancedFilters') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table
                            #dataTable
                            (onLazyLoad)="getProducts($event)"
                            [value]="primengTableHelper.records"
                            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                            [paginator]="false"
                            tableStyleClass="table table-bordered table-hover"
                            [lazy]="true"
                            [scrollable]="true"
                            ScrollWidth="100%"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            [resizableColumns]="primengTableHelper.resizableColumns"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.Products.Edit', 'Pages.Products.Delete')">
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="productCode">
                                        {{ l('ProductCode') }}
                                        <p-sortIcon field="product.productCode"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="barCode">
                                        {{ l('Barcode') }}
                                        <p-sortIcon field="product.productCode"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="name">
                                        {{ l('Name') }}
                                        <p-sortIcon field="product.name"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="unitFk.name">
                                        {{ l('Unit') }}
                                        <p-sortIcon field="unitName"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="departmentId">
                                        {{ l('Department') }}
                                        <p-sortIcon field="departmentId"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="categoryId">
                                        {{ l('Category') }}
                                        <p-sortIcon field="categoryId"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="brandId">
                                        {{ l('BrandName') }}
                                        <p-sortIcon field="brandId"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="unitCost">
                                        {{ l('UnitCost') }}
                                        <p-sortIcon field="product.unitCost"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="averageCost">
                                        {{ l('AverageCost') }}
                                        <p-sortIcon field="product.averageCost"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="price">
                                        {{ l('Price') }}
                                        <p-sortIcon field="product.price"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="QtyOnHand">
                                        {{ l('QtyOnHand') }}
                                        <p-sortIcon field="product.qtyOnHand"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="isActive">
                                        {{ l('Active') }}
                                        <p-sortIcon field="product.isActive"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.Products.Edit', 'Pages.Products.Delete')">
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.Products.Edit')"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/inventory/products/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.product.id }">
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.Products.Delete')"
                                                       (click)="deleteProduct(record.product)">
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Code') }}</span>
                                        {{ record.product.productCode }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Barcode ') }}</span>
                                        {{ record.product.barcode }}
                                    </td>
                                    <td style="width: 300px">
                                        <span class="p-column-title">{{ l('Name') }}</span>
                                        {{ record.product.name }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_Name_Here}}')}}</span>
                                        {{ record.unitName }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_DepartmentName_Here}}')}}</span>
                                        {{ record.departmentName }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_CategoryName_Here}}')}}</span>
                                        {{ record.categoryName }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_BrandName_Here}}')}}</span>
                                        {{ record.brandName }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('UnitCost') }}</span>
                                        {{ record.product.unitCost }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('AverageCost') }}</span>
                                        {{ record.product.averageCost }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('Price') }}</span>
                                        {{ record.product.price }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('QtyOnHand') }}</span>
                                        {{ record.product.qtyOnHand }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Active') }}</span>

                                        <div *ngIf="record.product.isActive" class="text-center">
                                            <i class="fa fa-check-circle text-success" title="True"></i>
                                        </div>

                                        <div *ngIf="!record.product.isActive" class="text-center">
                                            <i class="fa fa-times-circle" title="False"></i>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator
                                [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                #paginator
                                (onPageChange)="getProducts($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true"
                                [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "
                            ></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>

    <excel-column-selection-modal
        (modalSave)="exportToExcel($event)"
        #excelColumnSelectionModal
    ></excel-column-selection-modal>
</div>

<p-dialog 
  header="Import - Product" 
  [(visible)]="importDialoug" 
  [modal]="true" 
  [style]="{width: '600px'}" 
  [draggable]="false" 
  [resizable]="false"
>
  <div class="mb-3">
    <p>
      You can download the Template from the below link. Once downloaded, fill the
      relevant values and upload it.
    </p>
    <a href="{{downloadUrl}}" class="text-primary fw-semibold">Download Template</a>
  </div>

  <div class="mb-3">
    <small class="text-muted">
      You can import the Excel File for Creating records
    </small>
  </div>

  <ng-template pTemplate="footer">
    <button class="btn btn-danger" (click)="importDialoug=false">
      CANCEL
    </button>
    <a href="javascript:;" class="btn btn-primary ms-2 p-3 pt-0">
                            <p-fileUpload
                                    mode="basic"
                                    customUpload="true"
                                    name="ExcelFileUpload"
                                    #ExcelFileUpload
                                    maxFileSize="10000000"
                                    auto="auto"
                                    accept=".csv,.xls,.xlsx"
                                    (uploadHandler)="uploadExcel($event)"
                                    (onError)="onUploadExcelError()"
                                    (onUpload)="onUploadExcelSuccess()"
                                    chooseLabel="UPLOAD & IMPORT"
                                ></p-fileUpload>
                        </a>
  </ng-template>
</p-dialog>



<!-- <p-dialog header="Import Product" styleClass="my-custom-dialog" [modal]="true" [(visible)]="importDialoug" [style]="{ width: '100rem' }">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title"><span> Select Columns to Export Excel </span></h4>
            </div>
        </div>
    </div>
    <div class="modal-header">
            <h3 class="modal-title">
                <span>{{ l('Import') }}</span>
            </h3>
        </div>
        <div class="m-heading-1 border-green m-bordered">
            <p> {{ l('DownloadTemplate_Info') }} </p>
            <a href="#"> {{ l('DownloadTemplate') }}</a>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <p-fileUpload
                                    mode="basic"
                                    customUpload="true"
                                    name="ExcelFileUpload"
                                    #ExcelFileUpload
                                    maxFileSize="10000000"
                                    auto="auto"
                                    accept=".csv,.xls,.xlsx"
                                    (uploadHandler)="uploadExcel($event)"
                                    (onError)="onUploadExcelError()"
                                    chooseLabel="{{ 'ImportFromExcel' | localize }}"
                                ></p-fileUpload>
                <span class="help-block m-b-none">{{ l('ImportTemplate_Info') }}</span>
            </div>
        </div>
</p-dialog> -->
